export default "__VITE_ASSET__dhWBjuOR__"